import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DynamicGenericArticleFooter, DynamicMorningStudioArticleFooter } from "./dynamics";

type Props = {
  theme: Theme;
};

const CommonArticleFooterStyle = (props: Props) => css`
  max-inline-size: 1208px;
  margin-inline: auto;

  ${props.theme.breakpoints.up("tablet")} {
    margin-block-end: 80px;
  }
`;

export const StyledGenericArticleFooter = styled(DynamicGenericArticleFooter)`
  ${CommonArticleFooterStyle}

  ${props => props.theme.breakpoints.only("mobile")} {
    margin-block-start: 38px;
  }
`;

export const StyledMorningStudioArticleFooter = styled(DynamicMorningStudioArticleFooter)`
  ${CommonArticleFooterStyle}
`;
